import { render, staticRenderFns } from "./FAQTable.vue?vue&type=template&id=76dce8b8&scoped=true&"
import script from "./FAQTable.vue?vue&type=script&lang=js&"
export * from "./FAQTable.vue?vue&type=script&lang=js&"
import style0 from "./FAQTable.vue?vue&type=style&index=0&id=76dce8b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dce8b8",
  null
  
)

export default component.exports